export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_10.15bd1351.png";